import React from 'react';
import { Link } from 'react-router-dom';
import { ITEM_TYPE, ROUTING, PATH } from '../../../../../constants';
import * as api from '../../../../../api';
import * as textHelper from '../../../../../utils/TextHelper';
import './HomeLineItem.css';

// todo - maybe find some way to extend ListItem (duplicate pieces of code)

const getLink = (itemClass, linkUrl, style, linkContent) => (
  <a
    className={itemClass}
    style={style}
    href={linkUrl}
    target="_blank"
    rel="noopener noreferrer"
  >
    {linkContent}
  </a>
);

const HomeLineItem = ({ grid, topic, itemData, marginLeft }) => {
  let imgUrl = '';
  let ico = '';
  let route = '';
  let isCategory = false;
  const itemId = itemData[0];
  const mainData = itemData[1];

  // images
  switch (mainData.type) {
    case ITEM_TYPE.VIDEO:
    case ITEM_TYPE.MEMORY:
      ico = 'play';
      imgUrl = api.videoImageUrl(mainData);
      break;
    case ITEM_TYPE.ARTICLE:
      ico = 'read';
      imgUrl = `${PATH.IMG}articles/${mainData.image_id}.jpg`;
      break;
    case ITEM_TYPE.CATEGORY:
      isCategory = true;
      break;
    default:
  }

  // route
  if (isCategory) {
    route = `${ROUTING.CATEGORY}/${mainData.categoryId}`;
  } else {
    route = `${ROUTING.DETAIL}/${itemData[0]}`;
  }

  // just for normal type
  let titleClass = 'title';
  let topics = [];
  if (!isCategory) {
    // title class
    if (mainData.title.length > 60) {
      titleClass = `${titleClass} longest`;
    } else if (mainData.title.length > 40) {
      titleClass = `${titleClass} long`;
    }

    // topics
    topics = mainData.topic.map((topicItem, index) => {
      const key = `${itemId}-topic-${index}`;
      return (
        <div className="topic-bullet" key={key}>{topicItem}</div>
      );
    });
  }

  // content
  const linkContent = (
    <div className="item-wrap">
      <div className="img-cont">
        {isCategory &&
        <React.Fragment>
          <img
            className="category-ico"
            src={`${PATH.IMG}homepage/ico-home-line-${mainData.categoryId}.png`}
            alt=""
          />
          <div className="hint">Otevřít celou kategorii</div>
        </React.Fragment>
        }
        {!isCategory &&
        <React.Fragment>
          <img
            className="thumb"
            src={imgUrl}
            alt={mainData.title}
          />
          {ico.length > 0 &&
          <img
            className="ico"
            src={`${PATH.IMG}ico/ico-${ico}.png`}
            alt="Přehrát"
          />
          }
        </React.Fragment>
        }
      </div>
      {!isCategory &&
      <React.Fragment>
        <div className="date-wrap">
          {mainData.timeline.length > 0 &&
          <div className="date">{mainData.timeline}</div>
          }
        </div>
        <div className={titleClass}>{textHelper.formatText(mainData.title)}</div>
        <div className="topics">{topics}</div>
      </React.Fragment>
      }
    </div>
  );

  // size
  const style = {
    width: `${100 / grid}%`,
    marginLeft,
  };

  // main class
  let itemClass = 'home-list-item';
  if (topic) {
    itemClass = `${itemClass} topic-item`;
  }

  // link
  // todo - article ios hotfix - revise
  if (mainData.type === ITEM_TYPE.ARTICLE && api.isIOs()) {
    return getLink(itemClass, mainData.link, style, linkContent);
  }
  return (
    <Link
      className={itemClass}
      style={style}
      to={route}
    >
      {linkContent}
    </Link>
  );
};

export default HomeLineItem;



// WEBPACK FOOTER //
// ./src/components/App/Home/HomeLine/HomeLineItem/HomeLineItem.js